export default "__VITE_PUBLIC_ASSET__c4b8eb35__"